import React, { Component } from 'react';

class PageLoader extends Component {
  render(){

    return(
      <div className="page-loader">
        <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
        <span className="sr-only">Loading...</span>
      </div>
    );
  }
}
export default PageLoader;


// WEBPACK FOOTER //
// ./src/modules/pieces/PageLoader.js